export default {
  staticLinks: [
    { label: 'Forums', url: 'https://forums.envato.com' },
    { label: 'Start Selling', url: '/become-an-author' }
  ],
  envatoProducts: [
    {
      key: 'elements',
      name: 'Envato Elements',
      logo: '/images/logo-envato-elements.svg',
      description: 'Digital assets subscription',
      url: 'https://elements.envato.com'
    },
    {
      key: 'sites',
      name: 'Envato Sites',
      logo: '/images/logo-envato-sites.svg',
      description: 'Websites builder',
      url: 'https://sites.envato.com'
    },
    {
      key: 'studio',
      name: 'Envato Studio',
      logo: '/images/logo-envato-studio.svg',
      description: 'Hire a freelancer',
      url: 'https://studio.envato.com'
    },
    {
      key: 'tutsplus',
      name: 'Tuts+',
      logo: '/images/logo-envato-tutsplus.svg',
      description: 'Tutorials & courses',
      url: 'https://tutsplus.com'
    }
  ],
  envatoProductsStaticLinks: [
    {
      key: 'community',
      label: 'Join the ',
      linkLabel: 'Envato community',
      url: 'http://community.envato.com'
    },
    {
      key: 'forums',
      label: 'Learn from others in ',
      linkLabel: 'the forums',
      url: 'https://forums.envato.com'
    }
  ]
}



// WEBPACK FOOTER //
// ./config/layout/header.js